import React from 'react'
import BadgeSecondary from './BadgeSecondary.jsx'

export default function BadgeBudget(props){
	const {budget, bgColor} = props

	return (
    <BadgeSecondary
      icon={<i className="fa-regular fa-money-bill-wave"></i>}
      text={budget}
      bgColor={bgColor}
    />
	);
}